// extracted by mini-css-extract-plugin
export var videoHero = "_bx-4";
export var videoHeroImage = "_bx-5";
export var videoHeroOverlay = "_bx-6";
export var videoHeroSubtitle = "_bx-8";
export var videoHeroText = "_bx-7";
export var videoLauncher = "_bx-0";
export var videoLauncherIcon = "_bx-1";
export var videoLauncherSubtitle = "_bx-3";
export var videoLauncherTitle = "_bx-2";
export var videoPlayer = "_bx-a";
export var videoPlayerWrap = "_bx-9";